
import Vue from 'vue'
import {NewTabletsApiFunc, setAccessToken} from '@/api'
import { Tablet } from '@/models'

import TabletList from './components/TabletList.vue'
import TheTemplate from '../TheTemplate.vue'
import SearchForm from '@/components/BaseSearchForm.vue'
import Pager from '@/components/BasePager.vue'

export type FilterCondition = {
  status?: string;
  word?: string;
}

export type DataType = {
  tablets: Array<Tablet>;
  filterCondition: FilterCondition;
  totalPage: number;
  currentPage: number;
}

export default Vue.extend({
  name: 'TabletListScreen',

  data(): DataType {
    return {
      tablets: [],
      filterCondition: {
        word: undefined,
        status: undefined,
      },
      totalPage: 0,
      currentPage: 0,
    }
  },

  computed: {
    isAdmin(): boolean {
      return this.$auth.role === "admin"
    }
  },

  mounted() {
    this.fetchTablets()
  },

  watch: {
    $route(to, from) {
      if (to.params.updated === 'true') {
        this.fetchTablets(this.currentPage)
      }
    }
  },

  components: {
    TheTemplate,
    SearchForm,
    TabletList,
    Pager
  },

  methods: {
    async fetchTablets(page?: number): Promise<void> {
      const companyId = this.$auth.companyId
      if (!companyId) {
        this.$router.replace({name: 'login'})
        return
      }
      const filterString: string = JSON.stringify({
        q: this.filterCondition.word,
        status: this.filterCondition.status,
      })
        setAccessToken(this.$auth.accessToken)
        const { data, err } = await NewTabletsApiFunc().listTablets(companyId, filterString, page)

      if (err != null) {
        this.$handleApiError(err, () => {
          this.fetchTablets(page)
        })
        return
      }

      this.tablets = data.list
      this.currentPage = data.currentPage
      this.totalPage = data.totalPage
    },

    updateFilterCondition(condition?: FilterCondition): void {
      this.filterCondition = Object.assign(this.filterCondition, condition)
    },

    changePage(page: number): void {
      this.fetchTablets(page)
    }
  }
})
